export const usmle2PsychModule = {
  id: "psych",
  title: "Psychiatry",
  sections: [
    {
      type: "text",
      content:
        "Major depressive disorder: at least 2 weeks of depressed mood or anhedonia with functional impairment.",
    },
    {
      type: "question",
      text: "Mania lasting at least 1 week indicates:",
      options: ["Bipolar I", "Bipolar II", "Cyclothymia", "Dysthymia"],
      correct: 0,
      explanation: "Bipolar I includes manic episodes lasting >= 1 week.",
    },
  ],
};
